export const DASHBOARD_TABS = [
  { key: "vendas", label: "Vendas Realizadas" },
  { key: "falhas", label: "Falhas de Pagamento" },
  { key: "cancelamentos", label: "Cancelamentos" },
  { key: "usuarios", label: "Total de usuários" },
  { key: "pagantes", label: "Total de pagantes" },
  { key: "ticket", label: "Ticket médio" },
  { key: "arr", label: "ARR" },
];

export function formatDashValue(value, format, rowType) {
  if (value === null || value === undefined || value === "") return "";
  if (rowType === "plan_header") return "";
  if (typeof value === "string") return value;
  const number = Number(value);
  if (Number.isNaN(number)) return String(value);
  if (format === "brl") {
    return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(number);
  }
  if (format === "count") {
    return new Intl.NumberFormat("pt-BR", { maximumFractionDigits: 0 }).format(number);
  }
  return new Intl.NumberFormat("pt-BR", { maximumFractionDigits: 2 }).format(number);
}

export function buildAntdColumns(columns) {
  const result = [];
  const groups = new Map();

  (columns || []).forEach((col) => {
    const item = {
      title: col.label || col.id,
      dataIndex: col.id,
      key: col.id,
      render: (value, row) => formatDashValue(value, col.format, row.row_type),
    };
    if (col.group) {
      if (!groups.has(col.group)) {
        const groupCol = { title: col.group, children: [] };
        groups.set(col.group, groupCol);
        result.push(groupCol);
      }
      groups.get(col.group).children.push(item);
      return;
    }
    result.push(item);
  });

  return result;
}

export function tableToCsvRows(table) {
  const columns = table?.columns || [];
  const rows = table?.rows || [];
  return rows.map((row) => {
    const out = {};
    columns.forEach((col) => {
      out[col.id] = formatDashValue(row[col.id], col.format, row.row_type);
    });
    return out;
  });
}

export function tableToCsvHeaders(table) {
  return (table?.columns || []).map((col) => ({
    label: col.group ? `${col.group} ${col.label || col.id}` : col.label || col.id,
    key: col.id,
  }));
}

export function stackedBarToPlotData(chart) {
  const categories = chart?.categories || [];
  const series = chart?.series || [];
  const data = [];
  series.forEach((item) => {
    (item.values || []).forEach((value, idx) => {
      data.push({
        category: categories[idx] || "",
        group: item.name,
        value: Number(value) || 0,
      });
    });
  });
  return data;
}

export function pieToPlotData(chart) {
  const labels = chart?.labels || [];
  const values = chart?.values || [];
  return labels.map((label, idx) => ({
    type: label,
    value: Number(values[idx]) || 0,
  }));
}

export function seriesColorMap(chart) {
  const map = {};
  (chart?.series || []).forEach((item) => {
    if (item.name && item.color) map[item.name] = item.color;
  });
  return map;
}
